export default __webpack_public_path__ + "static/media/check.58f597fe.png";